<div class="flex flex-col h-full bg-white overflow-hidden">
  <!-- Barre du haut : bouton Retour -->
  <div class="shrink-0 h-[88px] border-t border-b border-gris-3 grid grid-cols-[1fr_auto_1fr] px-5 items-center">
    <button type="button" (click)="goBack()"
      class="justify-self-start border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
      {{ 'common.back' | translate }}
    </button>

    <!-- Centre : filtre par statut -->
    <div class="flex items-center gap-[10px]">
      @for (filter of statusFilters; track filter.value) {
      <button type="button"
        class="flex items-center gap-[10px] h-[48px] px-[15px] py-[9px] rounded-[30px] cursor-pointer transition-colors shrink-0"
        [class]="statusFilter() === filter.value ? filter.bg : 'bg-white border ' + filter.border"
        (click)="setStatusFilter(filter.value)">
        <div class="size-[10px] rounded-full shrink-0" [class]="statusFilter() === filter.value ? 'bg-white' : filter.bg">
        </div>
        <span class="text-[19px] font-semibold whitespace-nowrap"
          [class]="statusFilter() === filter.value ? 'text-white' : filter.fg">{{ filter.labelKey | translate }}</span>
      </button>
      }
    </div>

    <!-- Droite : recherche par numéro ou par jour de session -->
    <div class="flex items-center gap-[10px] justify-end">
      <label
        class="flex items-center gap-[10px] h-[48px] px-[20px] rounded-[5px] w-[190px] overflow-hidden border border-gris-3 cursor-text transition-colors hover:border-gris-2 focus-within:border-bleu-1">
        <input type="number" min="1" step="1" [formControl]="sessionNumberControl"
          class="flex-1 text-[16px] fg-noir-2 outline-none bg-transparent min-w-0 border-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          [placeholder]="'session_list.search.id_placeholder' | translate" />
        <app-svg class="fg-gris-2 shrink-0" height="20" svgPath="assets/svg/search.svg" width="20" />
      </label>
      <div class="relative flex items-center">
        <button type="button" (click)="openDatePicker()"
          class="flex items-center gap-[10px] h-[48px] px-[15px] rounded-[5px] border border-gris-3 bg-white cursor-pointer transition-colors hover:border-gris-2"
          [class.border-bleu-1]="dateControl.value" [title]="'session_list.search.date_label' | translate"
          [attr.aria-label]="'session_list.search.date_label' | translate">
          <span class="material-icons fg-gris-1 text-[22px]">calendar_today</span>
          @if (dateControl.value) {
          <span class="text-[16px] fg-noir-2 whitespace-nowrap">{{ dateControl.value | date: 'dd/MM/yyyy' }}</span>
          }
        </button>
        @if (dateControl.value) {
        <button type="button" (click)="clearDate()"
          class="ml-[5px] size-[48px] flex items-center justify-center rounded-[5px] border border-gris-3 bg-white cursor-pointer hover:bg-gris-4 transition-colors"
          [attr.aria-label]="'session_list.search.clear_date' | translate">
          <span class="material-icons fg-gris-1 text-[20px]">close</span>
        </button>
        }
      </div>
    </div>
  </div>

  <!-- Contenu principal -->
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col overflow-hidden border border-gris-3">
      <h2 class="text-[20px] font-semibold fg-noir-2 px-5 pt-5 pb-[15px] shrink-0 leading-none">
        {{ 'session_list.title' | translate }}
      </h2>

      <div class="flex-1 flex flex-col overflow-hidden min-h-0 mx-5 mb-5">
        <!-- En-tête du tableau -->
        <div class="flex items-center px-[15px] py-[15px] bg-white rounded-t-[5px] shrink-0">
          <button type="button" (click)="setSort('id')"
            class="min-w-[80px] flex-1 flex items-center justify-center gap-[5px] text-[16px] font-semibold cursor-pointer bg-transparent border-0 p-0"
            [class.fg-vert-1]="sort() === 'id'" [class.fg-noir-2]="sort() !== 'id'">
            {{ 'session_list.col.number' | translate }}
            @if (sort() === 'id') {
            <span class="material-icons text-[18px]">{{ sortIcon() }}</span>
            }
          </button>
          <span class="text-[16px] font-semibold fg-noir-2 min-w-[126px] flex-1 text-center">
            {{ 'session_list.col.status' | translate }}
          </span>
          <span class="text-[16px] font-semibold fg-noir-2 min-w-[150px] flex-1 text-center">
            {{ 'session_list.col.opened_at' | translate }}
          </span>
          <button type="button" (click)="setSort('closed_at')"
            class="min-w-[150px] flex-1 flex items-center justify-center gap-[5px] text-[16px] font-semibold cursor-pointer bg-transparent border-0 p-0"
            [class.fg-vert-1]="sort() === 'closed_at'" [class.fg-noir-2]="sort() !== 'closed_at'">
            {{ 'session_list.col.closed_at' | translate }}
            @if (sort() === 'closed_at') {
            <span class="material-icons text-[18px]">{{ sortIcon() }}</span>
            }
          </button>
          <span class="text-[16px] font-semibold fg-noir-2 min-w-[126px] flex-1 text-center">
            {{ 'session_list.col.action' | translate }}
          </span>
        </div>

        <!-- Lignes du tableau -->
        <div class="flex-1 overflow-y-auto">
          @if (isLoading()) {
          <div class="flex items-center justify-center py-[40px] bg-white">
            <app-loader size="w-8 h-8" />
          </div>
          } @else {
          @for (session of sessions(); track session.id) {
          <div class="flex items-center px-[15px] py-[10px] bg-white border-t border-gris-3 w-full">
            <span class="text-[16px] font-medium fg-gris-1 min-w-[80px] flex-1 text-center">
              #{{ session.remote_id ?? session.id }}
            </span>

            <div class="min-w-[126px] flex-1 flex justify-center">
              <span
                class="inline-flex items-center justify-center px-[20px] h-[41px] rounded-[30px] text-[16px] font-semibold text-white"
                [class.bg-vert-1]="session.status === 'open'" [class.bg-gris-2]="session.status === 'closed'">
                {{ 'session_list.status.' + session.status | translate }}
              </span>
            </div>

            <span class="text-[16px] font-medium fg-gris-1 min-w-[150px] flex-1 text-center">
              {{ session.opened_at | date: 'dd/MM/yyyy HH:mm' }}
            </span>

            <span class="text-[16px] font-medium fg-gris-1 min-w-[150px] flex-1 text-center">
              {{ (session.closed_at | date: 'dd/MM/yyyy HH:mm') ?? '—' }}
            </span>

            <div class="min-w-[126px] flex-1 flex justify-center">
              @if (session.status === 'closed') {
              <button type="button" (click)="generateZTicket(session)"
                class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center justify-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors bg-white">
                {{ 'session_list.z_ticket.button' | translate }}
              </button>
              }
            </div>
          </div>
          }

          @if (sessions().length === 0) {
          <div class="flex items-center justify-center py-[40px] bg-white">
            <span class="text-[16px] fg-gris-1">
              {{ 'session_list.empty' | translate }}
            </span>
          </div>
          }
          }
        </div>

        @if (pagination(); as currentPagination) {
        <app-pagination [pagination]="currentPagination" [disabled]="isLoading()" (pageChange)="loadPage($event)" />
        }
      </div>
    </div>
  </main>
</div>

@if (showDatePicker()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-date-picker class="w-[560px]" [value]="dateControl.value || null" (dateSelect)="onDateSelected($event)"
    (clearClick)="onDateCleared()" (cancelClick)="closeDatePicker()" />
</div>
}
